import React from 'react'
import Navbar from './NavBar'
import Footer from './Footer'
import Header from './Header'

interface SidebarProps {
  sidebarState: boolean
  sidebarToggleState: () => void
}

const Sidebar: React.FC<SidebarProps> = ({ sidebarState, sidebarToggleState }) => {
  return (
    <div
      className={`sidebar z-50 ${sidebarState ? 'translate-x-0' : '-translate-x-full'} md:absolute md:translate-x-0 fixed inset-0 overflow-hidden h-screen w-[65vw] md:pl-5 md:w-[25vw] lg:w-[20vw] xl:w-[16vw] 2xl:w-[14vw] md:max-w-full flex flex-col justify-between p-5 md:p-0 bg-cents-white md:bg-cents-grey transition-all duration-500`}
    >
      <Header sidebarToggleState={sidebarToggleState} sidebarState={sidebarState} />
      <div>{/* <Picklist /> */}</div>
      <Navbar sidebarToggleState={sidebarToggleState} />
      <Footer />
    </div>
  )
}

export default Sidebar
